import React from 'react'
import { Box, Typography, Paper } from '@mui/material'
import GavelIcon from '@mui/icons-material/Gavel'

/**
 * Encabezado estándar de sección para todas las páginas
 */
export default function PageHeader({ title, subtitle, icon: Icon = GavelIcon }) {
  return (
    <Paper
      elevation={0}
      sx={{
        mb: 3,
        px: { xs: 2.5, md: 3.5 },
        py: { xs: 2.5, md: 3 },
        background: '#ffffff',
        border: '1px solid #e0e0e0',
        borderRadius: 2,
        display: 'flex',
        alignItems: 'center',
        gap: 2,
        position: 'relative',
        overflow: 'hidden',
        boxShadow: '0 8px 22px rgba(0, 0, 0, 0.06)',
      }}
    >
      <Box sx={{ bgcolor: '#f5f5f5', borderRadius: 2, p: 1.25, display: 'flex' }}>
        <Icon sx={{ color: '#333333', fontSize: 30 }} />
      </Box>
      <Box sx={{ position: 'relative', zIndex: 1 }}>
        <Typography variant="h5" sx={{ color: '#000000', fontWeight: 800, lineHeight: 1.1 }}>
          {title}
        </Typography>
      </Box>
    </Paper>
  )
}
